import { useCallback, useEffect, useMemo, useState } from "react";
import { getLandedCostTariffHistory } from "../../API/landedCostTariffHistoryApi";

const extractRows = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (payload && typeof payload === "object") {
    const candidates = ["queryResults", "elements", "data", "rows", "content"];
    for (const key of candidates) {
      if (Array.isArray(payload[key])) {
        return payload[key];
      }
    }
  }
  return [];
};

export const useLandedCostTariffHistory = () => {
  const [rawRows, setRawRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    try {
      const history = await getLandedCostTariffHistory();
      setRawRows(history || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  const rows = useMemo(() => extractRows(rawRows), [rawRows]);

  return { rows, loading, fetchHistory };
};

export default useLandedCostTariffHistory;
